var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_value),expression:"new_value"}],staticClass:"form-control full_src",domProps:{"value":(_vm.new_value)},on:{"input":function($event){if($event.target.composing)return;_vm.new_value=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }